import sileo from 'sileo';

const Accountability = new sileo.Model('hqzen', 'accountabilities');
const AccountabilityAttachment = new sileo.Model('hqzen', 'accountability-amazon-form-data');
const AccountabilityEmployees = new sileo.Model('hqzen', 'accountability-employees');
const AccountabilityEditHistory = new sileo.Model('applybpo', 'accountability-edit-history');
const AccountabilityAcknowledgement = new sileo.Model('hqzen', 'accountability-acknowledgement');
const EmployeeAccountabilityItemDetail = new sileo.Model('hqzen', 'employee-accountabilities-detail');
const EmployeeAccountabilities = new sileo.Model('hqzen', 'employee-accountabilities');
const EmployeeAccountabilitiesCount = new sileo.Model('hqzen', 'employee-accountabilities-count');
const CurrencyDescription = new sileo.Model('exchange', 'description');


const state = {};

const getters = {};

const mutations = {};

const actions = {
    fetchCurrencyDescription() {
        return CurrencyDescription.objects.filter();
    },

    fetchEmployeeAccountabilitiesItemDetail(context, pk) {
        return EmployeeAccountabilityItemDetail.objects.get(pk);
    },
    fetchEmployeeAccountabilities(context, filters) {
        return Accountability.objects.filter(filters);
    },


    fetchAccountabilityEditHistory(context, filters) {
        return AccountabilityEditHistory.objects.filter(filters);
    },

    updateAccountability(context, data) {
        return Accountability.objects.update({}, data).then(response => {
            return response;
        }).catch(error => {
            return error;
        });
    },

    createAccountability(context, data) {
        const form = new FormData();
        for (let key in data) {
            form.append(key, data[key]);
        }
        return Accountability.objects.create(form);
    },

    deleteAccountability(context, data) {
        return Accountability.objects.delete(data);
    },

    fetchAccountabilityEmployees(context, filters) {
        return AccountabilityEmployees.objects.filter(filters);
    },

    updateAcknowledgeAccountability(context, payload) {
        let signature = payload.signature;
        let formData = new FormData();
        return new Promise((resolve, reject) => {
            signature.save(async(blob) => {
                formData.append('signature_file', blob, 'signature.png');
                delete payload.signature;
                for (let key in payload) {
                    formData.append(key, payload[key]);
                }
                resolve(await AccountabilityAcknowledgement.objects.update({}, formData));
            });
        });
    },

    fetchEmployeeListAccountabilities(context, filters) {
        return EmployeeAccountabilities.objects.filter(filters);
    },

    fetchEmployeeAccountabilitiesCount(context, filters) {
        return EmployeeAccountabilitiesCount.objects.filter(filters);
    },

    async fetchAccountabilityAmazonFormData(context, file_type) {
        return AccountabilityAttachment.objects.filter(
            { file_type: file_type }).then(data => {
                return data.amazon;
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
